<template>
  <SectionWrapper title="내일매출 당겨받기" :to="to" :subtitle="subtitle" :no-content="isExecuting">
    <InvestingSection v-if="investingPullRevenue && !isExecuting" :loan="investingPullRevenue" />
    <RepaymentSection v-else-if="executedPullRevenue" :loan="executedPullRevenue" />
  </SectionWrapper>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    SectionWrapper: () => import('@/components/main/SectionWrapper.vue'),
    InvestingSection: () => import('@/components/main/cards/InvestingSection.vue'),
    RepaymentSection: () => import('@/components/main/cards/RepaymentSection.vue'),
  },

  computed: {
    ...mapGetters('loan', [
      'isPullRevenueOfferRequest',
      'investingPullRevenue',
      'executedPullRevenue',
    ]),

    to() {
      if (this.executedPullRevenue) {
        return { name: 'loan/repayment', params: { uuid: this.executedPullRevenue.uuid } }
      }

      return { name: 'loan/pull-revenue' }
    },

    subtitle() {
      if (this.isExecuting) {
        return '계약서 작성이 완료되어 송금 준비중 입니다.'
      }

      if (this.executedPullRevenue) {
        const {
          executedAt,
          offer: { periodInDays },
        } = this.executedPullRevenue
        const excStr = this.$moment(executedAt).format('YYYY-MM-DD')
        const expStr = this.$moment(executedAt).add(periodInDays, 'days').format('YYYY-MM-DD')

        return `${excStr} 실행 ~ ${expStr} 만기`
      }

      return null
    },

    isExecuting() {
      return this.investingPullRevenue?.status === 'executing'
    },
  },
}
</script>

<style lang="scss" scoped></style>
